/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Confirm_ApproveInputs */

const vi_pl_pxk_confirm_approve = /** @type {(inputs: Pl_Pxk_Confirm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt phiếu xuất lô chè mua này?`)
};

/**

* @param {Pl_Pxk_Confirm_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_confirm_approve = /** @type {((inputs?: Pl_Pxk_Confirm_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Confirm_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_confirm_approve(inputs)
});